import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import config from 'src/shared/config';
import { mainPageRouteTables, singleRouteTable } from 'src/shared/routes';

import BaseLayout from './BaseLayout';
import { MainPageWrapper } from './MainPage';
import SingleLayout from './SingleLayout';

import 'src/components/index.scss';

// menus 가져오기
const Layout: React.FC = () => {
  return (
    <Routes>
      {singleRouteTable.map((rt) => (
        <Route
          key={rt.fullPath}
          path={rt.fullPath}
          element={
            <SingleLayout>{rt.component ? <rt.component /> : <>TODO : ERROR</>}</SingleLayout>
          }
        />
      ))}
      <Route path="/" element={<BaseLayout />}>
        {/* <Route path={"dashboard"} element={<MainPageWrapper />} /> */}
        {mainPageRouteTables.map((routeTable) => {
          // console.log(routeTable);
          return (
            <Route
              key={routeTable.fullPath}
              path={routeTable.fullPath}
              element={<MainPageWrapper routeTable={routeTable} />}
            />
          );
        })}
      </Route>
      <Route path="*" element={<Navigate to={config.url('/errors/not-found')} />} />
    </Routes>
  );
};

export default Layout;
